import { render, staticRenderFns } from "./m-form-block.vue?vue&type=template&id=254c4d70&scoped=true&lang=pug&"
import script from "./m-form-block.vue?vue&type=script&lang=js&"
export * from "./m-form-block.vue?vue&type=script&lang=js&"
import style0 from "./m-form-block.vue?vue&type=style&index=0&id=254c4d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c4d70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VRow})
